module.exports = __webpack_public_path__ + "static/media/evaluating-sm.701a0270.gif";